import { render } from "./course2.vue?vue&type=template&id=9f42cd16&scoped=true"
import script from "./course2.vue?vue&type=script&lang=js"
export * from "./course2.vue?vue&type=script&lang=js"

import "./course2.vue?vue&type=style&index=0&id=9f42cd16&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f42cd16"]])

export default __exports__